'use es6';

import * as DSAssetFamilies from 'customer-data-filters/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { Map as ImmutableMap, OrderedMap, OrderedSet, Set as ImmutableSet } from 'immutable';
import emptyFunction from 'react-utils/emptyFunction';
import identity from 'transmute/identity';
export const getListSegFilterFamilyOptions = ({
  blocklist = ImmutableSet(),
  fixedValues = ImmutableMap(),
  // eslint-disable-next-line
  hasGate = emptyFunction.thatReturnsFalse,
  hasScope = emptyFunction.thatReturnsFalse,
  isEnabled = emptyFunction.thatReturnsFalse
} = {}) => {
  const result = OrderedMap({
    [DSAssetFamilies.CONTACT_PROPERTY]: true,
    [DSAssetFamilies.COMPANY_PROPERTY]: true,
    [DSAssetFamilies.DEAL_PROPERTY]: hasScope('crm-access'),
    [DSAssetFamilies.ENGAGEMENT_PROPERTY]: true,
    [DSAssetFamilies.LINE_ITEM_PROPERTY]: hasScope('crm-access'),
    [DSAssetFamilies.CONTACT_LIST]: hasScope('contacts-lists-access'),
    [DSAssetFamilies.FORM]: hasScope('forms-access'),
    [DSAssetFamilies.EMAIL_CAMPAIGN]: true,
    [DSAssetFamilies.EMAIL_SUBSCRIPTION]: true,
    [DSAssetFamilies.CONTACT_IMPORT]: true,
    [DSAssetFamilies.PAGE_VIEW]: hasScope('reports-page-view-filtering-access'),
    [DSAssetFamilies.PRODUCT_PROPERTY]: hasScope('crm-access'),
    [DSAssetFamilies.EVENT]: hasScope('events-analytics'),
    [DSAssetFamilies.WORKFLOW]: hasScope('workflows-access'),
    [DSAssetFamilies.CTA]: hasScope('cta-access'),
    [DSAssetFamilies.GOTO_WEBINAR_WEBINAR]: isEnabled(DSAssetFamilies.GOTO_WEBINAR_WEBINAR),
    [DSAssetFamilies.SURVEY_MONKEY_SURVEY]: isEnabled(DSAssetFamilies.SURVEY_MONKEY_SURVEY),
    [DSAssetFamilies.SURVEY_MONKEY_QUESTION]: isEnabled(DSAssetFamilies.SURVEY_MONKEY_QUESTION),
    [DSAssetFamilies.ADS_PROPERTY]: isEnabled(DSAssetFamilies.ADS_PROPERTY)
  }).merge(fixedValues).filter((_, key) => !blocklist.has(key)).filter(identity);
  return OrderedSet.fromKeys(result);
};